// src/components/PrivacyPolicy.jsx
import React from 'react';
import styles from '../styles/PrivacyPolicy.module.css';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
    return (
        <div>
            <Nav />
            <div className={styles.privacyContainer}>
                <header className={styles.header}>
                    <h1 className={styles.title}>Privacy Policy</h1>
                    <p className={styles.subtitle}>StockKhata - Invest Anywhere, Maintain Only Here</p>
                </header>
                <main className={styles.content}>
                    <section>
                        <h2 className={styles.sectionTitle}>Introduction</h2>
                        <p>
                            At StockKhata, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal information when you use our website and services. By accessing or using StockKhata, you agree to the terms outlined in this policy. If you do not agree, please refrain from using our platform.
                        </p>
                    </section>

                    <section>
                        <h2 className={styles.sectionTitle}>Information We Collect</h2>
                        <p>
                            We may collect the following types of information:
                        </p>
                        <ul className={styles.list}>
                            <li>
                                <strong>Personal Information:</strong> Name, email address, phone number, and other details you provide when creating an account or contacting us.
                            </li>
                            <li>
                                <strong>Financial Information:</strong> Portfolio data, investment preferences, and other details you input to track your investments (we do not store payment information directly).
                            </li>
                            <li>
                                <strong>Usage Data:</strong> Information about how you interact with our website, such as IP address, browser type, pages visited, and time spent on the platform.
                            </li>
                            <li>
                                <strong>Cookies:</strong> We use cookies and similar technologies to enhance your experience and analyze usage patterns. You can manage cookie preferences through your browser settings.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2 className={styles.sectionTitle}>How We Use Your Information</h2>
                        <p>
                            We use your information to:
                        </p>
                        <ul className={styles.list}>
                            <li>Provide and improve our services, including portfolio tracking and user support.</li>
                            <li>Personalize your experience on StockKhata.</li>
                            <li>Communicate with you, including sending updates, notifications, or responses to inquiries.</li>
                            <li>Analyze usage trends to enhance platform functionality and security.</li>
                            <li>Comply with legal obligations and protect against fraudulent activities.</li>
                        </ul>
                        <p>
                            We do not sell, trade, or rent your personal information to third parties for marketing purposes.
                        </p>
                    </section>

                    <section>
                        <h2 className={styles.sectionTitle}>Data Sharing and Disclosure</h2>
                        <p>
                            We may share your information in the following circumstances:
                        </p>
                        <ul className={styles.list}>
                            <li>
                                <strong>Service Providers:</strong> With trusted third-party vendors who assist us in operating our platform (e.g., hosting, analytics), bound by confidentiality agreements.
                            </li>
                            <li>
                                <strong>Legal Requirements:</strong> When required by law, court order, or government authority.
                            </li>
                            <li>
                                <strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your data may be transferred as part of the transaction.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2 className={styles.sectionTitle}>Data Security</h2>
                        <p>
                            We implement reasonable technical and organizational measures to protect your personal information from unauthorized access, loss, or misuse. However, no online platform can guarantee absolute security, and you share information with us at your own risk.
                        </p>
                    </section>

                    <section>
                        <h2 className={styles.sectionTitle}>Your Rights</h2>
                        <p>
                            Depending on your location, you may have the following rights regarding your personal data:
                        </p>
                        <ul className={styles.list}>
                            <li>Access, correct, or delete your personal information.</li>
                            <li>Opt-out of certain data collection or communications.</li>
                            <li>Request a copy of your data in a portable format.</li>
                        </ul>
                        <p>
                            To exercise these rights, contact us at{' '}
                            <a href="mailto:info@stockkhata.in" className={styles.link}>
                                info@stockkhata.in
                            </a>.
                        </p>
                    </section>

                    <section>
                        <h2 className={styles.sectionTitle}>Third-Party Links</h2>
                        <p>
                            Our platform may include links to external websites. We are not responsible for the privacy practices or content of these third-party sites. We encourage you to review their privacy policies.
                        </p>
                    </section>

                    <section>
                        <h2 className={styles.sectionTitle}>Changes to This Policy</h2>
                        <p>
                            We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date. Your continued use of StockKhata after such changes constitutes acceptance of the revised policy.
                        </p>
                    </section>

                    <section>
                        <h2 className={styles.sectionTitle}>Contact Us</h2>
                        <p>
                            If you have questions or concerns about this Privacy Policy, please reach out to us at{' '}
                            <a href="mailto:info@stockkhata.in" className={styles.link}>
                                info@stockkhata.in
                            </a>{' '}
                            or call us at +91 7500068589.
                        </p>
                    </section>
                </main>

            </div>
            <Footer />
        </div>

    );
};

export default PrivacyPolicy;